// extracted by mini-css-extract-plugin
export default {"main":"_6a84acc5e6","tit":"_02f16c5f19","maintitle":"b1ca9c3048","ylw":"a06b561475","white":"_2c848c97d9","mv_title":"_10e3c96b2e","mv_nc":"_45a01f8281","mv_in":"cfa655cdca"};